import React from 'react';

import './index.scss';

const EstimationResult = ({responses}) => {
  return <p className='estimation-result'>
    { responses ? `You should receive around 80% of RSVP responses by ${responses}` :'Add your data to see the result' }</p>;
};

export default EstimationResult;
